const RadiosDetailAdapter = components => {
    let result = [];

    if (!(components && Array.isArray(components))) {
        console.log('La api no contiene componentes');
        return result;
    }

    result = components.map(radio => {
        let obj = {};
        obj = {
            band: radio.band || null,
            dial: radio.dial,
            encoding: radio.encoding,
            id: radio.id,
            image: radio.img,
            isFavorite: radio.isFavorite,
            name: radio.name,
            subType: 'musicStations',
            title: radio.title,
            url: radio.service_url,
            entity_id: radio.entity_id,
            entity: radio.entity,
            num_tracks: radio.num_tracks,
            type: radio.type,
            action: radio.action,
            author: radio.author,
            duration: radio.duration
        };
        return obj;
    });
    return result;
};

export default RadiosDetailAdapter;


// WEBPACK FOOTER //
// ./src/components/Radios/RadiosDetailAdapter.js